<template>
    <v-form ref="form">
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            outlined
                            counter
                            label="线索备注"
                            v-model="remarkData.remarks"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <v-row >
                    <v-col cols="6">
                        <v-row justify="center">
                            <v-btn color="error" dark @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}
                            </v-btn>
                        </v-row>
                    </v-col>
                    <v-col cols="6">
                        <v-row justify="center">
                            <v-btn color="success" dark @click="updateRemark">{{ $vuetify.lang.t('$vuetify.custom.okBtn') }}</v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-form>
</template>
<style></style>
<script>
export default {
    name: 'mark-remark',
    model: {
        prop: 'remarkDialog',
        event: 'parent-event'
    },
    props: {
        remarkData: Object,
        remarkDialog: Boolean
    },
    mounted() {
    },
    data: () => ({
    }),
    watch: {

    },
    methods: {
        updateRemark(){
            this.$api.clew.updateRemarksByClewId(this.remarkData).then(data => {
                if (data.flag) {
                    this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.updateSuccess'));
                    this.$emit('initBaseMsg')
                    this.hiddenDialog();
                } else {
                    this.$dialog.alert(data.msg)
                }
            })
        },
        hiddenDialog() {
            this.$emit('parent-event', false);
        },
    },
}
</script>
